const cardDueMaskAA = (value) => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d{2})/, '$1/$2')
    .replace(/(.{7})\d+?$/, '$1');
};

export default cardDueMaskAA;
